import { FontSizes, FontWeights, ICheckboxStyles } from "@fluentui/react";

export const checkBoxStyle: ICheckboxStyles = {
  label: {
    fontWeight: FontWeights.semibold,
     whiteSpace: 'nowrap',
    fontSize: FontSizes.size10,
    color: '#a9a9a9',
  },
};